(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxRegisterPrinter(
    $timeout, Utils, $http, toastr, $filter, NetworkListPaging, PrinterListService,
    $location, RegexModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        network: '=network',
        enums: '=enums',
        me: '=me',
        printer: '=printer',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerIssue/registerPrinter/registerPrinter.template.html',
      link: function(scope) {

        scope.invalidPrinterData = true;
        scope.focus = false;

        var mac_regex = /\b((([0-9A-Fa-f]{2}:{1,17}){5}([0-9a-fA-F]{2}))|(([0-9A-Fa-f]{2}){5}([0-9a-fA-F]{2})))\b/i; 
        var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;

        const BAD_STRING_NAME = new RegexModel().badNameString().regex;
        scope.BAD_STRING_NAME = new RegexModel().badNameString().string;

        scope.printerNameInvalid = false;
        scope.locationNameInvalid = false;

        scope.pdlsMap = {
          PCL5: {
            selected: false
          },
          PCLXL: {
            selected: false
          },
          POSTSCRIPT: {
            selected: false
          },
          PDF: {
            selected: false
          },
          XPS: {
            selected: false
          },
          UFRII: {
            selected: false
          }
        };

        (function() {
          setPrinter();
          setVendors();
          validatePrinterInput();
        })();


        $timeout(function () {
          scope.focus = true;
        }, 300)

        function setPrinter () {
          scope.newPrinter = {
           
            name: null,
            vendor: null,
            vendorTyped: null,
            model: null,
            ipAddress: scope.context.printer.info.ipAddress,
            macAddress: null,
            serialNumber: null,
            colorSupport: false,
            duplexSupport: false,
            
            
          };
        };

        

        function setVendors () {
          scope.currentVendor = null;
          for (var i = 0; i < scope.enums.Vendor.length; i++) {
            if (scope.enums.Vendor[i].id === scope.context.printer.info.vendor) {
              if (scope.enums.Vendor[i].id === 'UNKNOWN') {
                var vendor = {
                  id: 'UNKNOWN',
                  name: $filter('translate')('Select')
                }

                scope.enums.Vendor[i].name = $filter('translate')('EnterVendorName');

                scope.currentVendor = vendor;
              } else {
                scope.currentVendor = scope.enums.Vendor[i];
              }
              break;
            }
          }

          scope.enums.Vendor = sortList(scope.enums.Vendor);
          for (var i = 0; i < scope.enums.Vendor.length; i++) {
            if (scope.enums.Vendor[i].id === 'UNKNOWN') {
              var unknown = scope.enums.Vendor[i];
              scope.enums.Vendor.splice(i, 1);
              scope.enums.Vendor.unshift(unknown);
              break;
            }
          }

          
          scope.selectDataObject = {
            listRaw: scope.enums.Vendor,
            placeholderText: 'Select',
            skipOrderByName: true,
            printerRegistration: true
          };
        }


        function sortList(filtersList) {
          filtersList.sort(function(a, b) {
            var a = a.name.toLowerCase();
            var b = b.name.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
          return filtersList;
        }
        

        function validatePrinterInput () {
          var printerIsInvalid = false;
          scope.macAddressInvalid = true;
          scope.ipAddressInvalid = true;
          

          for (var key in scope.newPrinter) {
            if (key === 'vendor' || key === 'model' || key === 'macAddress' || key === 'ipAddress') {
              if (!scope.newPrinter[key]) {
                printerIsInvalid = true;
              }
              
              if (key === 'macAddress' && scope.newPrinter[key]) {
                if (!scope.newPrinter[key].match(mac_regex)) {
                  printerIsInvalid = true;
                  scope.macAddressInvalid = true;
                } else {
                  scope.macAddressInvalid = false;
                }
              }

              if (key === 'vendor' && scope.newPrinter[key] === 'UNKNOWN') {
                if (!scope.newPrinter.vendorTyped) {
                  printerIsInvalid = true;
                }
              }
            }
            if (key === 'name') {
              if (!scope.newPrinter.name) {
                printerIsInvalid = true;
              } else {
                if (scope.newPrinter.name.match(BAD_STRING_NAME)?.length > 0) {
                  scope.printerNameInvalid = true;
                  printerIsInvalid = true;
                } else {
                  scope.printerNameInvalid = false;
                }
              }
            } 
            
            if (key === 'location') {
              if (BAD_STRING_NAME.test(scope.newPrinter?.location)) {
                scope.locationNameInvalid = true;
                printerIsInvalid = true;
              } else {
                scope.locationNameInvalid = false;
              }
            }
          }
          scope.invalidPrinterData = printerIsInvalid;
        }

        scope.selectNetworks = function () {
          scope.networkPaginationObject = new NetworkListPaging();
          scope.selectingVendor = false;
        }

        scope.closeSelectNetworkDialog = function (network) {
          if (network) {
            scope.network = network;
          }
          scope.networkPaginationObject = null;
        }

        scope.selectVendor = function (vendor) {
          scope.newPrinter.vendor = vendor.id;
          
          if (vendor.id === 'UNKNOWN') {
            $timeout(function () {
              angular.element('#Type_Vendor_Name').focus();
            }, 100)
          }

          validatePrinterInput()
        }

        scope.validatePrinterInputAgain = function () {
          validatePrinterInput();      
        }


        scope.saveNewPrinter = function () {
          var url = scope.tenant.info._links['px:printers'].href  + '?list&failOnDuplicate=true';

          var printer = {
            vendor: scope.newPrinter.vendor !== 'UNKNOWN' ? scope.newPrinter.vendor : scope.newPrinter.vendorTyped,
            model: scope.newPrinter.model,
            printerName: scope.newPrinter.name,
            networkUid: scope.network.customProperties.id,
            IP: scope.newPrinter.ipAddress,
            MAC: cleanupGateway(scope.newPrinter.macAddress),
            SN: scope.newPrinter.serialNumber,
            location: scope.newPrinter.location,
            PDLs: pdlsAsEnums(scope.pdlsMap),
            colorSupport: scope.newPrinter.colorSupport,
            duplexSupport: scope.newPrinter.duplexSupport,
            ieee1284: null
          };

          var printerlist = [];
          printerlist.push(printer);

          $http.post(url, printerlist).then(function(response) {
            toastr.success($filter('translate')('PrinterAdded'));
            scope.callback();
            if (!scope.meta.rerouteOverride) {
              $location.path('/printers');
            }
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
        }

        function cleanupGateway (mac) {
          return mac.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }

        function pdlsAsEnums (pdls) {
          var pdlsEnums = [];

          for (var key in pdls) {
            if (pdls[key].selected === true) {
              pdlsEnums.push(key);
            }
          }

          return pdlsEnums;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;  
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop; 
          if (showTip) { 
            position.startX = position.startX - offsetLeft; 
            position.startY = position.startY - offsetTop;
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement',
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }



      }
    };
  }

  pxRegisterPrinter.$inject = [
    '$timeout', 'Utils', '$http', 'toastr', '$filter', 'NetworkListPaging', 'PrinterListService',
    '$location', 'RegexModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxRegisterPrinter', pxRegisterPrinter);

})();
